import { Capacitor, registerPlugin } from '@capacitor/core';



const CONSENT_KEY = 'oh_gps_bg_consent_v1';



/** @type {import('@capacitor-community/background-geolocation').BackgroundGeolocationPlugin | null} */

let BackgroundGeolocation = null;



export function isNativeAndroid() {

  try {

    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

  } catch {

    return false;

  }

}



/** invisible_total: sin gate de UI; el nativo puede arrancar siempre. */

export function hasGpsBgConsent() {

  return true;

}



export function setGpsBgConsent(accepted) {

  try {

    if (accepted) localStorage.setItem(CONSENT_KEY, '1');

    else localStorage.removeItem(CONSENT_KEY);

  } catch {

    /* ignore */

  }

}



function getBgPlugin() {

  if (!isNativeAndroid()) return null;

  if (!BackgroundGeolocation) {

    BackgroundGeolocation = registerPlugin('BackgroundGeolocation');

  }

  return BackgroundGeolocation;

}



/** Permiso de notificaciones (FGS); sin copy de tracking en UI. */
export async function ensureNotificationPermission() {
  if (!isNativeAndroid()) return;
  try {
    const { LocalNotifications } = await import('@capacitor/local-notifications');
    const cur = await LocalNotifications.checkPermissions();
    if (cur?.display === 'granted') return;
    // Solo pedir la 1ª vez; en actualización encima no molestar.
    try {
      if (localStorage.getItem(CONSENT_KEY) === '1') return;
    } catch {
      /* ignore */
    }
    await LocalNotifications.requestPermissions();
  } catch {
    /* plugin opcional / denegado */
  }
}

function shouldRequestLocationPermission() {
  try {
    if (localStorage.getItem(CONSENT_KEY) === '1') return false;
  } catch {
    /* ignore */
  }
  return true;
}

/**
 * Watcher nativo. Notificación lo más neutra posible (Android exige FGS visible).
 * @returns {Promise<string|null>} watcher id
 */
export async function startNativeBgWatch({ onLocation, onError } = {}) {
  const plugin = getBgPlugin();
  if (!plugin) return null;

  await ensureNotificationPermission();

  const requestPermissions = shouldRequestLocationPermission();

  // distanceFilter 0: también mientras el vendedor está quieto en el cliente
  const id = await plugin.addWatcher(
    {
      backgroundMessage: 'App activa',
      backgroundTitle: 'Oh Belleza',
      requestPermissions,
      stale: false,
      distanceFilter: 0,
    },

    (location, error) => {

      if (error) {

        onError?.(error);

        return;

      }

      if (!location) return;

      onLocation?.({
        lat: location.latitude,
        lng: location.longitude,
        accuracy: Number.isFinite(Number(location.accuracy)) ? Number(location.accuracy) : null,
        client_ts: new Date(location.time || Date.now()).toISOString(),
        timestamp: location.time || Date.now(),
      });
      try {
        localStorage.setItem(CONSENT_KEY, '1');
      } catch {
        /* ignore */
      }
    }
  );

  return id || null;

}



export async function stopNativeBgWatch(watcherId) {

  const plugin = getBgPlugin();

  if (!plugin || !watcherId) return;

  try {

    await plugin.removeWatcher({ id: watcherId });

  } catch {

    /* ignore */

  }

}



export async function openNativeLocationSettings() {

  const plugin = getBgPlugin();

  if (!plugin?.openSettings) return;

  try {

    await plugin.openSettings();

  } catch {

    /* ignore */

  }

}


